export enum Role {
  ANONYMOUS_GUEST_USER = "ANONYMOUS_GUEST_USER",
  VIP_GUEST_USER = "VIP_GUEST_USER",
  VISITOR_GUEST_USER = "VISITOR_GUEST_USER",
  PUBLIC_GUEST_USER = "PUBLIC_GUEST_USER",
  STUDENT_USER = "STUDENT_USER",
  TEACHER_USER = "TEACHER_USER",
}
